import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { FaEnvelope, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const EmailNotifications = () => {
  const { fetchWithRetry } = useAuth();
  const [settings, setSettings] = useState({
    newMessage: false,
    interestedInMe: false,
    newFriend: false,
    interactionsInterestedIn: false,
    addMeAsFriend: false,
    preferredMatches: false,
    compatibleUsers: false,
    eventInvite: false,
    cupidMediaAds: false,
    newMessageRealTime: false,
    interestedInMeRealTime: false,
    newFriendRealTime: false,
    interactionsInterestedInRealTime: false,
    addMeAsFriendRealTime: false,
    preferredMatchesRealTime: false,
    compatibleUsersRealTime: false,
    eventInviteRealTime: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetchWithRetry({ method: "get", url: "/api/users/email-notifications" });
        setSettings(response.data);
      } catch (err) {
        setError("Không thể tải cài đặt thông báo email!");
      }
    };
    fetchSettings();
  }, [fetchWithRetry]);

  const handleToggle = (key) => {
    setSettings({ ...settings, [key]: !settings[key] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await fetchWithRetry({
        method: "put",
        url: "/api/users/email-notifications",
        data: settings,
      });
      setSuccess("Cập nhật cài đặt thông báo thành công!");
    } catch (err) {
      setError(err.response?.data?.message || "Lỗi khi cập nhật cài đặt thông báo!");
    } finally {
      setLoading(false);
    }
  };

  const renderToggleSwitch = (key) => (
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={settings[key]}
        onChange={() => handleToggle(key)}
        className="hidden"
      />
      <div
        className={`relative w-11 h-6 rounded-full transition-colors duration-200 ease-in-out ${
          settings[key] ? "bg-green-500" : "bg-gray-200"
        }`}
      >
        <div
          className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-200 ease-in-out ${
            settings[key] ? "translate-x-5" : "translate-x-0"
          }`}
        ></div>
      </div>
    </label>
  );

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 flex items-center">
        <FaEnvelope className="mr-2" /> Thông Báo
      </h2>
      <p className="text-gray-600 mb-4">Cập nhật email của bạn và thông báo theo thời gian thực.</p>

      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 rounded flex items-center">
          <FaExclamationCircle className="mr-2" /> {error}
        </div>
      )}
      {success && (
        <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 rounded flex items-center">
          <FaCheckCircle className="mr-2" /> {success}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Cột Thông Báo Email */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Thông Báo Email</h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span>Tin nhắn mới:</span>
                {renderToggleSwitch("newMessage")}
              </div>
              <div className="flex justify-between items-center">
                <span>Quan tâm đến tói:</span>
                {renderToggleSwitch("interestedInMe")}
              </div>
              <div className="flex justify-between items-center">
                <span>Bạn mới:</span>
                {renderToggleSwitch("newFriend")}
              </div>
              <div className="flex justify-between items-center">
                <span>Những tương tác với hồ sơ của bạn:</span>
                {renderToggleSwitch("interactionsInterestedIn")}
              </div>
              <div className="flex justify-between items-center">
                <span>Có người đã thêm tói là người được ưa thích:</span>
                {renderToggleSwitch("addMeAsFriend")}
              </div>
              <div className="flex justify-between items-center">
                <span>Người ứng đối tiềm ẩn:</span>
                {renderToggleSwitch("preferredMatches")}
              </div>
              <div className="flex justify-between items-center">
                <span>Người tương thích:</span>
                {renderToggleSwitch("compatibleUsers")}
              </div>
              <div className="flex justify-between items-center">
                <span>Lời mời sự kiện:</span>
                {renderToggleSwitch("eventInvite")}
              </div>
            </div>
          </div>

          {/* Cột Thông Báo Theo Thời Gian Thực */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Thông Báo Theo Thời Gian Thực</h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span>Tin nhắn mới:</span>
                {renderToggleSwitch("newMessageRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Quan tâm đến tói:</span>
                {renderToggleSwitch("interestedInMeRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Bạn mới:</span>
                {renderToggleSwitch("newFriendRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Những tương tác với hồ sơ của bạn:</span>
                {renderToggleSwitch("interactionsInterestedInRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Có người đã thêm tói là người được ưa thích:</span>
                {renderToggleSwitch("addMeAsFriendRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Người ứng đối tiềm ẩn:</span>
                {renderToggleSwitch("preferredMatchesRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Người tương thích:</span>
                {renderToggleSwitch("compatibleUsersRealTime")}
              </div>
              <div className="flex justify-between items-center">
                <span>Lời mời sự kiện:</span>
                {renderToggleSwitch("eventInviteRealTime")}
              </div>
            </div>
          </div>
        </div>

        <h3 className="text-lg font-semibold mt-6 mb-2">Quảng cáo trên trang</h3>
        <div className="flex justify-between items-center">
          <span>Các trang web trong mạng lưới Cupid Media:</span>
          {renderToggleSwitch("cupidMediaAds")}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="mt-6 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-200 disabled:bg-gray-400"
        >
          {loading ? "Đang lưu..." : "Lưu thay đổi"}
        </button>
      </form>
    </div>
  );
};

export default EmailNotifications;